import {
    GET_MAIL_SETUP_LIST_PROGRESS, GET_MAIL_SETUP_LIST_SUCCESS, GET_MAIL_SETUP_LIST_FAILURE,
    ADD_MAIL_SETUP_PROGRESS, ADD_MAIL_SETUP_SUCCESS, ADD_MAIL_SETUP_FAILURE,
    EDIT_DELETE_MAIL_SETUP_PROGRESS, EDIT_DELETE_MAIL_SETUP_SUCCESS, EDIT_DELETE_MAIL_SETUP_FAILURE,
   
    RESET_MESSAGE,
    MAIL_SEND_ATTACHMENT_PROGRESS,
    MAIL_SEND_ATTACHMENT_SUCCESS,
    MAIL_SEND_ATTACHMENT_FAILURE,

} from '../types/actionTypes';

const initialState = {
    mailSetup: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null,
    mailSendAttachment: [],
}

const mailSetup_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_MAIL_SETUP_LIST_SUCCESS:
            return { ...state, mailSetup: action.mailSetup, loading: false };
        case GET_MAIL_SETUP_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_MAIL_SETUP_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_MAIL_SETUP_PROGRESS:
            return { ...state, loading: true };
        case ADD_MAIL_SETUP_SUCCESS:
            return { ...state, mailSetup: [...state.mailSetup, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_MAIL_SETUP_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
        case EDIT_DELETE_MAIL_SETUP_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_MAIL_SETUP_SUCCESS:
            return {
                ...state,
                mailSetup: state.mailSetup.map((mailSetup) =>
                mailSetup.id === action.payload.id ? action.payload : mailSetup
                ),  
                message: action.payload.message
            };
        case EDIT_DELETE_MAIL_SETUP_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
     
        case MAIL_SEND_ATTACHMENT_PROGRESS:
            return { ...state, loading: true };
        case MAIL_SEND_ATTACHMENT_SUCCESS:
            return { ...state, mailSendAttachment: [...state.mailSendAttachment, action.payload], loading: false, error: false, message: action.payload.message };
        case MAIL_SEND_ATTACHMENT_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default mailSetup_reducer;